import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Footer from "./NewFooter";
import Header from "./Header";
import axios from "axios";

const Error404 = () => {
  const getStatus = async () => {
    try {
      const response = await axios.post("/check-status", null, {
        headers: {
          "Content-Type": "application/json",
        },
      });
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getStatus();
  }, []);
  return (
    <>
      <Header />
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <p>404, page not found</p>
        <Link to="/searchjob">Go back</Link>
      </div>
      <Footer />
    </>
  );
};

export default Error404;
